import React, { useCallback, useEffect, useState } from "react";
import { Box, CardMedia, Typography } from "@mui/material";
import { Stack } from "@mui/system";
import useEmblaCarousel from "embla-carousel-react";
import { observer } from "mobx-react-lite";
import store from "../../mobx";

import { SubsectionStack } from "./SubsectionStack";
import { KeyboardArrowDown } from "@mui/icons-material";

export const FeaturesCarousel = observer(function FeaturesCarousel({
  title = "How can next-year help your business?",
  spacing = 8,
}) {
  const { isPhone } = store.mediaBreakpointStore;
  const [emblaRef, emblaApi] = useEmblaCarousel({
    loop: true,
    align: "center",
  });
  const [selectedIndex, setSelectedIndex] = useState(0);

  const items = [
    {
      src: "/screenshots/clipper-11-19-25.jpg",
      header: "Fast & Intuitive",
      text: (
        <>
          Whether you{"'"}re a beginner or a seasoned pro, Mix.Quick gets you
          idea to polished sound in record time.
          <br />
          <br />
          No more second-guessing or wasting hours on tweaks — just clean,
          punchy results fast.
        </>
      ),
    },
    {
      src: "/screenshots/clipper-11-19-25.jpg",
      header: "Auto Gain Matching",
      text: (
        <>
          Skip the constant level checks.
          <br />
          <br />
          Mix.Quick keeps your loudness consistent while you clip, saturate, and
          widen — so you stay in the zone.
        </>
      ),
    },
    {
      src: "/screenshots/clipper-11-19-25.jpg",
      header: "Built for Any Workflow",
      text: (
        <>
          From quick demos to final masters, Mix.Quick adapts to how you work.
          <br />
          <br />
          Use it as your all-in-one sound shaper or just for instant loudness
          matching with your favorite tools.
        </>
      ),
    },
    // {
    //   src: "/screenshots/saturator.jpg",
    //   header: "Auto Gain Matching",
    //   text: (
    //     <>
    //       Skip the constant level checks.
    //       <br />
    //       <br />
    //       Mix.Quick keeps your loudness consistent while you clip, saturate, and
    //       widen — so you stay in the zone.
    //     </>
    //   ),
    // },
    // {
    //   src: "/screenshots/stereo-widener.jpg",
    //   header: "Built for Any Workflow",
    //   text: (
    //     <>
    //       From quick demos to final masters, Mix.Quick adapts to how you work.
    //       <br />
    //       <br />
    //       Use it as your all-in-one sound shaper or just for instant loudness
    //       matching with your favorite tools.
    //     </>
    //   ),
    // },
  ];

  // Auto-scroll every n seconds
  useEffect(() => {
    const interval = setInterval(() => {
      if (!emblaApi) return;
      const nextIndex = (selectedIndex + 1) % items.length;
      emblaApi.scrollTo(nextIndex);
    }, 8e3);
    return () => clearInterval(interval);
  }, [emblaApi, selectedIndex, items.length]);

  useEffect(() => {
    if (!emblaApi) return;
    const onSelect = () => setSelectedIndex(emblaApi.selectedScrollSnap());
    emblaApi.on("select", onSelect);
    onSelect();
  }, [emblaApi]);

  return (
    <SubsectionStack title={title} spacing={spacing}>
      <Box ref={emblaRef} sx={{ width: "100vw", overflow: "hidden" }}>
        <Stack direction="row" sx={{ display: "flex" }}>
          {items.map(({ src, header, text }, index) => {
            return (
              <Box
                key={index}
                sx={{
                  flex: "0 0 100%",
                  px: 2,
                  boxSizing: "border-box",
                }}
              >
                <Stack
                  alignItems="center"
                  justifyContent="center"
                  spacing={2}
                  sx={{ px: 2 }}
                >
                  <Typography
                    textAlign="center"
                    sx={{
                      fontSize: 22,
                      lineHeight: "18px",
                      color: "white",
                      fontWeight: "bold",
                    }}
                  >
                    {header}
                  </Typography>

                  <CardMedia
                    component="img"
                    src={src}
                    sx={{
                      minWidth: 400,
                      maxWidth: 800,
                      borderRadius: 4,

                      objectFit: "contain",
                    }}
                  />

                  <Typography
                    textAlign="center"
                    sx={{ fontSize: 18, color: "white" }}
                  >
                    {text}
                  </Typography>
                </Stack>
              </Box>
            );
          })}
        </Stack>
      </Box>
    </SubsectionStack>
  );
});
